import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "category/society-and-culture",
  "use": "category/society-and-culture-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"category/society-and-culture\"><path d=\"M24 24l-1.36-2.41L13.8 5.33l-.33-.62-.7-1.28L14.23.71 12.91 0l-1 1.86L10.9 0 9.59.72l1.47 2.71-.28.57L10 5.47 1.23 21.81 0 24h22.7zM12.14 5.41L14 8.81H9.88l2-3.81zm2.53 17.09H9.21l2.73-5 2.49 4.5zm1.73 0l-3.78-6.87-.68-1.26-.71 1.3L7.5 22.5H2.56l6.52-12.19h5.73l6.63 12.19z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol